/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function MenuIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" {...props}>
            <path d="M4.16667 10C4.16667 10.4602 3.79357 10.8333 3.33333 10.8333C2.8731 10.8333 2.5 10.4602 2.5 10C2.5 9.53976 2.8731 9.16667 3.33333 9.16667C3.79357 9.16667 4.16667 9.53976 4.16667 10Z" />
            <path d="M5.83333 9.95C5.83333 9.51738 6.18404 9.16667 6.61667 9.16667H16.7167C17.1493 9.16667 17.5 9.51738 17.5 9.95V10.05C17.5 10.4826 17.1493 10.8333 16.7167 10.8333H6.61667C6.18404 10.8333 5.83333 10.4826 5.83333 10.05V9.95Z" />
            <path d="M2.5 14.1167C2.5 13.684 2.85071 13.3333 3.28333 13.3333H16.7167C17.1493 13.3333 17.5 13.684 17.5 14.1167V14.2167C17.5 14.6493 17.1493 15 16.7167 15H3.28333C2.85071 15 2.5 14.6493 2.5 14.2167V14.1167Z" />
            <path d="M2.5 5.78333C2.5 5.35071 2.85071 5 3.28333 5H16.7167C17.1493 5 17.5 5.35071 17.5 5.78333V5.88333C17.5 6.31596 17.1493 6.66667 16.7167 6.66667H3.28333C2.85071 6.66667 2.5 6.31596 2.5 5.88333V5.78333Z" />
        </svg>
    );
}
